import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { handleErrorToast } from '../CustomFunctions';
import './Advancedstats.css';
import Modal from "react-bootstrap/Modal";
const AdvancedStats = ({ showAdvanced, SetShowAdvanced, AEname }) => {
    const [letterstatsProject, SetLetterstataProject] = useState([])
    const [letterstats, SetLetterstata] = useState([])
    const [buffer, Setbuffer] = useState(true);
    const [bufferproject, SetbufferProject] = useState(true);
    const getLettersstatsProject = async () => {

        try {
            const res = await axios.get(`${BASE_URL}/siteproject/LetterAssignmentStatsProject/`);

            SetLetterstataProject(res.data);



        } catch (error) {
            handleErrorToast(error);
        } finally {
            Setbuffer(false)
        }
    };

    const getLettersstats = async () => {

        try {
            // const res = await axios.get(`${BASE_URL}/siteproject/LetterAssignmentStats/`);
            const res = await axios.get(`${BASE_URL}/siteproject/filterletterbyAE/${AEname ? AEname : 'null'}/`);
            SetLetterstata(res.data);



        } catch (error) {
            handleErrorToast(error);
        } finally {
            SetbufferProject(false)
        }
    };

    useEffect(() => {
        getLettersstatsProject();

    }, []);
    useEffect(() => {
        getLettersstats();

    }, [AEname]);
    console.log(letterstats, 'letterstattaa')
    const [toggle, setToggle] = useState(1)
    const [show, setShow] = useState(true)
    const handleShow = () => {
        SetShowAdvanced(!showAdvanced)
    }
    console.log(SetShowAdvanced)
    const handleClose = () => {
        console.log('clicked')
        SetShowAdvanced(!showAdvanced)
    }

    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Advance Stats of letter {toggle === 1 ? "Authority Engineers" : toggle === 2 ? "Projects" : toggle === 3 ? "Unassigned Projects" : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="advanced-stats-container">
                        <div className="toggle-button-area">




                            <button
                                className={toggle === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                onClick={() => setToggle(1)}
                            >
                                Authority Engineers
                            </button>
                            <button
                                className={toggle === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                onClick={() => setToggle(2)}
                            >
                                Projects
                            </button>
                            <button
                                className={toggle === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                onClick={() => setToggle(3)}
                            >
                                Unassigned Projects
                            </button>
                        </div>
                        <div className="advanced-stats-content">
                            {toggle === 1 &&
                                <section className="advanced-stats-section">

                                    <div className="advanced-stats-cards">

                                        {buffer ? (
                                            <div className="spinner-bgdatil"></div>
                                        ) :
                                            letterstats?.ae_stats
                                                ?.slice()
                                                .sort((a, b) => {

                                                    const nameA = a.authority_engineer_name.toLowerCase();
                                                    const nameB = b.authority_engineer_name.toLowerCase();
                                                    return nameA.localeCompare(nameB);
                                                })
                                                .map((engineer, index) => (
                                                    <div key={index} className="advanced-stats-card">
                                                        <div className="engineer-profile">
                                                            <div className="engineer-avatar">
                                                                {engineer.authority_engineer_name.split(' ').map(n => n[0]).join('')}
                                                            </div>
                                                            <div className="engineer-info">
                                                                <h3 className="engineer-name">{engineer.authority_engineer_name}</h3>
                                                                <p className="engineer-email">{engineer.authority_engineer_email}</p>
                                                            </div>
                                                        </div>

                                                        <div className="engineer-stats-grid">
                                                            <div className="stat-item">
                                                                <span className="stat-label">Total Letters</span>
                                                                <span className="stat-value">{engineer.total_letters_for_ae}</span>
                                                            </div>
                                                            <div className="stat-item">
                                                                <span className="stat-label">Assigned</span>
                                                                <span className="stat-value">{engineer.total_assigned_letters}</span>
                                                            </div>
                                                            <div className="stat-item">
                                                                <span className="stat-label">Unassigned</span>
                                                                <span className="stat-value">{engineer.total_unassigned_letters}</span>
                                                            </div>
                                                            <div className="stat-item">
                                                                <span className="stat-label">Pending</span>
                                                                <span className="stat-value warning">{engineer.pending_letter}</span>
                                                            </div>
                                                            <div className="stat-item">
                                                                <span className="stat-label">Closed</span>
                                                                <span className="stat-value success">{engineer.closed_letter}</span>
                                                            </div>

                                                        </div>

                                                        <div className="progress-track">
                                                            <div
                                                                className="progress-bar"
                                                                style={{ width: `${engineer.completionRate}%` }}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                </section>



                            }

                            {
                                toggle === 2 &&
                                <section className="advanced-stats-section">

                                    <div className="advanced-stats-table-container">
                                        <table className="advanced-stats-table">
                                            <thead>
                                                <tr>
                                                    <th>Project Name</th>
                                                    <th>Engineer</th>
                                                    <th>Total</th>
                                                    <th>Assigned</th>
                                                    <th>Unassigned</th>
                                                    <th>Pending</th>
                                                    <th>Closed</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bufferproject ? (
                                                    <div className="spinner-bgdatil"></div>
                                                ) : letterstatsProject?.project_stats?.filter((i) => i?.authority_engineer)?.map((project, index) => (
                                                    <tr key={index}>
                                                        <td className="project-name-cell">
                                                            <span className="project-name">{project.project_name}</span>
                                                        </td>
                                                        <td>{project.
                                                            authority_engineer}</td>
                                                        <td>{project.total_letters_for_project
                                                        }</td>
                                                        <td>{project.
                                                            total_assigned_letter}</td>
                                                        <td>{project.total_unassigned_letters
                                                        }</td>
                                                        <td className={project.
                                                            pending_letter > 0 ? 'warning' : ''}>
                                                            {project.
                                                                pending_letter}
                                                        </td>
                                                        <td className={project.closed_letter > 0 ? 'success' : ''}>
                                                            {project.closed_letter}
                                                        </td>
                                                        <td>
                                                            <div className="completion-container">
                                                                <div className="progress-track">
                                                                    <div
                                                                        className="progress-bar"
                                                                        style={{ width: `${project.completionRate}%` }}
                                                                    ></div>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            }

                            {
                                toggle === 3 && <section className="advanced-stats-section">

                                    <div className="advanced-stats-table-container">
                                        <table className="advanced-stats-table">
                                            <thead>
                                                <tr>
                                                    <th>Project Name</th>
                                                    <th>Engineer</th>
                                                    <th>Total</th>
                                                    <th>Assigned</th>
                                                    <th>Unassigned</th>
                                                    <th>Pending</th>
                                                    <th>Closed</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bufferproject ? (
                                                    <div className="spinner-bgdatil"></div>
                                                ) : letterstatsProject?.project_stats?.filter((i) => !i?.authority_engineer)?.map((project, index) => (
                                                    <tr key={index}>
                                                        <td className="project-name-cell">
                                                            <span className="project-name">{project.project_name}</span>
                                                        </td>
                                                        <td>{project.
                                                            authority_engineer || "Unassigned"}</td>
                                                        <td>{project.total_letters_for_project
                                                        }</td>
                                                        <td>{project.
                                                            total_assigned_letter}</td>
                                                        <td>{project.total_unassigned_letters
                                                        }</td>
                                                        <td className={project.
                                                            pending_letter > 0 ? 'warning' : ''}>
                                                            {project.
                                                                pending_letter}
                                                        </td>
                                                        <td className={project.closed_letter > 0 ? 'success' : ''}>
                                                            {project.closed_letter}
                                                        </td>
                                                        <td>
                                                            <div className="completion-container">
                                                                <div className="progress-track">
                                                                    <div
                                                                        className="progress-bar"
                                                                        style={{ width: `${project.completionRate}%` }}
                                                                    ></div>
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            }
                        </div>
                    </div>

                </Modal.Body>


            </Modal>

        </>
    );
};

export default AdvancedStats;